import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import { IAPICompanyRes } from '../../model/api-modules';
import {
  IBKReportErrorBody,
  IBKReportTimeCostBody,
} from '../../model/api-modules/bk-report';
import { API_PREFIX } from '../config';

export const reportBKPageError = (body: IBKReportErrorBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/bk/report`;
      const response = await api.commonRequest('POST', url, body);
      await parsedResponse<IAPICompanyRes | null>(response, 'data', true);
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  });

export const reportBKTimeCost = (body: IBKReportTimeCostBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/bk/report`;
      const response = await api.commonRequest('POST', url, body);
      await parsedResponse<IAPICompanyRes | null>(response, 'data', true);
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  });
